'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _interceptUpdater = require('coact-utils/interceptUpdater');

var _interceptUpdater2 = _interopRequireDefault(_interceptUpdater);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _withProps = require('recompose/withProps');

var _withProps2 = _interopRequireDefault(_withProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO move toArray to codev-utils
function toArray(value) {
  if (Array.isArray(value)) return value;

  if (value === null || value === undefined) return [];
  return [value];
}

function makeToValue(_ref) {
  var refKeys = _ref.refKeys;

  if (refKeys) return function (doc) {
    return doc && doc._id || doc;
  };
  return function (value) {
    return value;
  };
}
function makeToLabel(_ref2) {
  var refKeys = _ref2.refKeys;

  if (refKeys) return function (doc) {
    return doc && refKeys.map(function (key) {
      return doc[key];
    }).join('-');
  };
  return function (value) {
    return value;
  };
}
function makeOptionAdapter(props) {
  var formatter = props.formatter;

  var toLabel = formatter || makeToLabel(props);
  var toValue = formatter || makeToValue(props);

  return function (option) {
    return {
      value: toValue(option),
      label: toLabel(option)
    };
  };
}

function buildDisplayOptions(_ref3) {
  var options = _ref3.options,
      optionAdapter = _ref3.optionAdapter;

  var optionBySelected = {};
  var optionsForDisplay = options.map(function (opt) {
    var display = optionAdapter(opt);
    optionBySelected[display.value] = opt;
    return display;
  });

  return {
    optionsForDisplay: optionsForDisplay,
    optionBySelected: optionBySelected
  };
}

function adaptValue(_ref4) {
  var multi = _ref4.multi,
      value = _ref4.value,
      optionAdapter = _ref4.optionAdapter;

  if (multi) return toArray(value).map(function (v) {
    return optionAdapter(v).value;
  });
  return optionAdapter(value).value;
}

var parseSelected = function parseSelected() {
  return function (selected) {
    // clear text return null
    if (selected === null) return null;

    // backspace return empty array `[]`
    if (Array.isArray(selected) && selected.length === 0) return null;

    if (Array.isArray(selected)) return selected.map(function (o) {
      return o.value;
    });

    return selected.value;
  };
};
var handleSelectedToOption = function handleSelectedToOption(_ref5) {
  var multi = _ref5.multi,
      optionBySelected = _ref5.optionBySelected;
  return function (selected) {
    var selectedOptions = toArray(selected).map(function (s) {
      return optionBySelected[s];
    });
    return multi ? selectedOptions : selectedOptions[0];
  };
};

var shape = _propTypes2.default.shape,
    any = _propTypes2.default.any,
    func = _propTypes2.default.func,
    array = _propTypes2.default.array,
    bool = _propTypes2.default.bool;

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  schema: shape({
    refKeys: array
  }),
  options: array.isRequired,
  onChange: func.isRequired,
  value: any,
  formatter: func
}), (0, _injectProps2.default)({
  multi: bool
}), (0, _flattenDefaultProp2.default)('schema'),

// optionAdapter is a funciton map value/doc to option
(0, _withPropsOnChange2.default)(['formatter'], function (props) {
  return {
    optionAdapter: makeOptionAdapter(props)
  };
}), (0, _withPropsOnChange2.default)(['options', 'optionAdapter'], buildDisplayOptions), (0, _withProps2.default)(function (props) {
  return { value: adaptValue(props) };
}), (0, _interceptUpdater2.default)('onChange', handleSelectedToOption), (0, _interceptUpdater2.default)('onChange', parseSelected), (0, _exposeProps2.default)(function (_ref6) {
  var optionsForDisplay = _ref6.optionsForDisplay;
  return {
    options: optionsForDisplay
  };
}), (0, _exposeProps2.default)(['value', 'onChange', 'multi']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'adaptReactSelect');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Select/adaptReactSelect.js
// module id = 1696
// module chunks = 0